import React from "react";
const DATA = [
  {
    title: "For Home Cooks",
    subtitle: "Personalized Home Cooking Made Easy!",
    description:
      "Discover personalized recipes tailored to your taste and dietary needs. Cook confidently, even for picky eaters, with easy instructions and AI assistance.",
  },
  {
    title: "For Foodies & Chefs",
    subtitle: "Access the Flavors of the World at Your Fingertips!",
    description:
      "Elevate your cooking with diverse recipes enriched by cultural stories and expert techniques. Experiment, innovate, and share your culinary creations.",
  },
  {
    title: "For Enterprises",
    subtitle: "Culinary Perks for Your Team!",
    description:
      "Empower your employees with a unique benefit through our Foodie membership and tailored Recipe Collections developed with your corporate dietitian.",
  },
];
// Card Component
const FeatureCard = ({ title, subtitle, description }) => {
  return (
    <div
      className="p-4 bg-white rounded-lg shadow-lg flex flex-col justify-between border w-full min-h-[352px] max-w-[378px] bg-opacity-40"
      style={{ boxShadow: "0px 0px 30px 0px #AC779D" }}
    >
      <h2 className="text-2xl font-extrabold leading-[42px] text-center text-[#1D1D1D] py-2 rounded-md font-raleway">
        {title}
      </h2>
      <p className="text-xl font-extrabold px-4 text-center text-[#A67FAA] font-raleway">
        {subtitle}
      </p>
      <p className="text-xl md:text-left text-black font-medium py-4 font-publicSans text-center">
        {description}
      </p>
    </div>
  );
};

// Main Component to Render the Cards
const FeatureRow = () => {
  return (
    <div className="flex flex-col md:flex-col lg:flex-row justify-center items-center p-0 md:p-10 lg:p-12 space-y-6 md:space-y-6 lg:space-y-0 lg:space-x-6">
      {DATA.map((data, index) => (
        <FeatureCard
          key={index}
          title={data.title}
          subtitle={data.subtitle}
          description={data.description}
        />
      ))}
    </div>
  );
};

export default FeatureRow;
